import { resetStoreTabs } from '../components/Tabs/Tab';
import { trackReset } from '../modules/analytics/trackingMiddleware';
import { resetInAppSession } from '../modules/close-the-loop';
import { clearForNextPerson } from '../storage/deviceStorage';
import { resetDashboardSession } from '../store/dashboardSession';

/**
 * Everything outside the query cache that this tab keeps for the signed-in person:
 * the in-app alerts already seen, the dashboard and store in view, what older code
 * still keeps on the device, and the analytics identity. All of it goes when they leave.
 */
export const forgetSignedInPerson = (): void => {
  resetInAppSession();
  resetDashboardSession();
  resetStoreTabs();
  clearForNextPerson();
  trackReset();
};

/**
 * A tab that finds no one signed in keeps nothing a previous person left on this device — a session that
 * ended without a sign-out here (expired overnight, ended elsewhere) leaves nothing for the next person.
 */
export const forgetPreviousPerson = (): void => {
  clearForNextPerson();
};
